import { render, staticRenderFns } from "./AppRiskConfigView.vue?vue&type=template&id=6619b28b&"
import script from "./AppRiskConfigView.vue?vue&type=script&lang=js&"
export * from "./AppRiskConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports